import React from 'react';
import FacilityStore from '../stores/FacilityStore';
import ViewerStore from '../stores/ViewerStore';
import { SplitterComponent, PanesDirective, PaneDirective } from '@syncfusion/ej2-react-layouts';
import * as Inovx from '@shared';
import { CheckBoxComponent, ChangeEventArgs, SpeedDialComponent, SpeedDialItemModel, SpeedDialItemEventArgs, SpeedDialAnimationSettingsModel } from '@syncfusion/ej2-react-buttons';

import ViewerConstants from './../constants/ViewerConstants';
import ViewerActions from '../actions/ViewerActions';
import ViewerHelpers from '../helpers/ViewerHelpers';
import ComponentHelpers from '../helpers/ComponentHelpers';
import { ColumnDirective, ColumnsDirective, CommandColumn, CommandModel, DetailRow, Grid, GridComponent, Inject, RowSelectEventArgs, RowSelectingEventArgs, Sort } from '@syncfusion/ej2-react-grids';
import FacilityActions from '../actions/FacilityActions';
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
const { useState, useEffect, useRef, useMemo } = React;

const ShowPointCloudButton = React.forwardRef((props: any, ref) => {
    const [isOpen, setIsOpen] = useState<boolean>(ViewerStore.isOpenPointCloud());

    const handleToggle = (event: SpeedDialItemEventArgs) => {
        const newState = !isOpen;
        setIsOpen(newState);
        FacilityActions.toggleAssemblyLibraryBar(false);
        ViewerActions.setOpenPointCloud(newState, false);
    };

    const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        
        handleToggle(event as unknown as SpeedDialItemEventArgs);
    };

    const speedDialRef = useRef(null);
    const iconClass = isOpen ? 'e-icons e-close' : 'e-icons e-point-cloud';
    let buttonClass = !isOpen ? 'e-point-cloud-white' : 'e-pano-white';
    const animation: SpeedDialAnimationSettingsModel = { effect: 'None' };
    const title = !isOpen ? "Point Cloud" : "Panoramic";
    useEffect(() => {
        const speedDialElement = speedDialRef.current;
        if (speedDialElement) {
            speedDialElement.addEventListener('click', handleToggle);
        }

        return () => {
            if (speedDialRef.current) {
                speedDialRef.current.removeEventListener('click', handleToggle);
            }
        };
    }, [isOpen]);

    {
        if (!ViewerStore.getSelectedKnowledgeView()?.Name && document.getElementById('PanoContainer')) {
            return <SpeedDialComponent
                ref={speedDialRef}
                target="#PanoContainer"
                id='pointcloud-actions'
                openIconCss={`e-icons ${buttonClass}`}
                clicked={handleToggle}  // Make sure this prop is properly passed
                position="BottomRight"
                onClick={handleClick}
                mode='Linear'
                title={title}
                enablePersistence={true}
                cssClass="pointCloudButton"
                direction='Up'
            />
        }
    }
    return <></>
});

export default ShowPointCloudButton;